import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ParamsSearchStatusBill, StatusBill } from "../types";
import fetchStatusBill from "../api/fetchStatusBill";


export const useFetchStatusBill = (): UseMutationResult<
  ApiResponse<StatusBill>,
  Error,
  ParamsSearchStatusBill
> => {
  return useMutation({
    mutationFn: (dataBillSearch: ParamsSearchStatusBill) =>
      fetchStatusBill(dataBillSearch),
  });
};